import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { MdTrendingUp, MdAccountBalance, MdBalance, MdBook, MdArrowBack } from 'react-icons/md';
import GradientCard from '../Common/GradientCard';

const Reports: React.FC = () => {
  const navigate = useNavigate();

  const reports = [
    {
      title: 'Profit & Loss',
      description: 'Revenue, cost of sales and operating expenses for any period with gross profit, net profit and margins.',
      icon: <MdTrendingUp />,
      path: '/accounting/reports/profit-loss',
      gradient: 'linear-gradient(135deg, #059669 0%, #10b981 100%)',
    },
    {
      title: 'Balance Sheet',
      description: 'Snapshot of total assets, liabilities and equity. Verifies: Assets = Liabilities + Equity.',
      icon: <MdAccountBalance />,
      path: '/accounting/reports/balance-sheet',
      gradient: 'linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)',
    },
    {
      title: 'Trial Balance',
      description: 'Summary of all account balances. Total debits must equal total credits.',
      icon: <MdBalance />,
      path: '/accounting/reports/trial-balance',
      gradient: 'linear-gradient(135deg, #dc2626 0%, #f87171 100%)',
    },
    {
      title: 'General Ledger',
      description: 'Full transaction history for any account with running balance.',
      icon: <MdBook />,
      path: '/accounting/ledger',
      gradient: 'linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%)',
    },
  ];

  return (
    <Container>
      <Header>
        <HeaderContent>
          <BackButton onClick={() => navigate('/accounting')}>
            <MdArrowBack />
            <span>Back to Accounting</span>
          </BackButton>
          <div>
            <Title>Financial Reports</Title>
            <Subtitle>
              Profit & Loss and Balance Sheet reports generated from your double-entry ledger
            </Subtitle>
          </div>
        </HeaderContent>
      </Header>

      <ReportsGrid>
        {reports.map((report) => (
          <GradientCard key={report.path} {...report} />
        ))}
      </ReportsGrid>
    </Container>
  );
};

const Container = styled.div`
  min-height: calc(100vh - 60px);
  background: #F8F9FA;
  padding: 32px;
  max-width: 1600px;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 20px;
  }
`;

const Header = styled.div`
  margin-bottom: 28px;
`;

const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const BackButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  background: white;
  border: 1px solid #D1D5DB;
  border-radius: 8px;
  color: #374151;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  width: fit-content;

  svg {
    font-size: 18px;
  }

  &:hover {
    border-color: #1e3a8a;
    color: #1e3a8a;
    background: #eff6ff;
  }
`;

const Title = styled.h1`
  font-size: 32px;
  font-weight: 700;
  color: #111827;
  margin: 0;
  letter-spacing: -0.5px;
`;

const Subtitle = styled.p`
  font-size: 15px;
  color: #6B7280;
  margin: 6px 0 0 0;
  line-height: 1.6;
  max-width: 800px;
`;

const ReportsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
  gap: 24px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export default Reports;

